import { gql, useMutation } from '@apollo/client';
import { REFETCH_USER_VIEWS } from './useUserViews';

export const DELETE_USER_VIEWS_MUTATION = gql`
  mutation DeleteUserViews($viewIds: [String!]!) {
    deleteUserViews(viewIds: $viewIds) {
      viewId
    }
  }
`;

export const useDeleteUserViews = () => {
  const [deleteUserViews, state] = useMutation(DELETE_USER_VIEWS_MUTATION, {
    refetchQueries: [REFETCH_USER_VIEWS],
  });

  return { deleteUserViews, ...state };
};
